import React from 'react';
import { Grid } from 'semantic-ui-react';
import PropTypes from 'prop-types';

export default function DurationBar({ maxDuration, stopDuration, color }) {
  stopDuration = stopDuration || 0;
  const widthPercentOfBar = (stopDuration / maxDuration) * 100;
  return (
    <Grid.Row className="duration-bar-row">
      <Grid.Column className="duration-bar" style={{ width: `${widthPercentOfBar}%`, background: color }} />
      {widthPercentOfBar < 75 && (
        <Grid.Column className="duration-bar" style={{ color: 'black', flexGrow: '1', textAlign: 'left' }} />
      )}
    </Grid.Row>
  );
}

DurationBar.propTypes = {
  maxDuration: PropTypes.number.isRequired,
  stopDuration: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired,
};
